const COLUMNS: { title: string; links: { label: string; href: string }[] }[] = [
  {
    title: '快速入口',
    links: [
      { label: '热度榜', href: '#ranking' },
      { label: '今日快讯', href: '#feed' },
      { label: '站点导航', href: '#sites' },
      { label: '深夜片单', href: '#night' },
    ],
  },
  {
    title: '资源分类',
    links: [
      { label: '剧情短片', href: '#categories' },
      { label: '纪录影像', href: '#categories' },
      { label: '文艺片单', href: '#categories' },
      { label: '悬疑连播', href: '#categories' },
    ],
  },
  {
    title: '关于本站',
    links: [
      { label: '常见问题', href: '#faq' },
      { label: '更新说明', href: '#feed' },
      { label: '站点收录', href: '#sites' },
      { label: '更新提醒', href: '#subscribe' },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="border-t border-foreground-950/10 bg-background-100">
      <div className="h-1 w-full bg-primary-500" />
      <div className="px-4 md:px-8 pt-12 pb-10">
        <div className="grid grid-cols-2 md:grid-cols-12 gap-8 md:gap-6">
          <div className="col-span-2 md:col-span-5">
            <div className="flex items-center gap-2">
              <span className="w-2.5 h-2.5 rounded-full bg-primary-500" />
              <span className="font-heading font-black text-2xl text-foreground-950">小电影</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 max-w-sm">
              小电影在线观看导航页，整理当前可用的高清视频网站与免费看片入口。热门小电影视频资源每日更新，打开就能直接播。
            </p>
            <div className="mt-5 flex items-center gap-2 text-xs text-foreground-500 font-label">
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-refresh-line" />
              </span>
              最近更新：2026-10-10 21:15
            </div>
          </div>

          {COLUMNS.map((col) => (
            <div key={col.title} className="md:col-span-2">
              <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-3">{col.title}</h4>
              <ul className="space-y-2.5">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="md:col-span-1">
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-3">状态</h4>
            <span className="inline-flex items-center gap-1.5 text-xs text-secondary-900 bg-secondary-100 border border-secondary-200 rounded-full px-2.5 py-1 whitespace-nowrap">
              <span className="w-1.5 h-1.5 rounded-full bg-accent-500" />
              巡线正常
            </span>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-foreground-950/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            © 2026 小电影 · 本站为导航整理页，仅做站点与资源索引，不提供内容存储。
          </p>
          <p className="text-xs text-foreground-500 font-label tracking-wide">
            小电影在线观看 · 小电影免费观看 · 高清小电影资源
          </p>
        </div>
      </div>
    </footer>
  );
}